// extracted by mini-css-extract-plugin
export default {"container":"ContentSection_container__HnmwA","title":"ContentSection_title__yt4Ou","body":"ContentSection_body__t9vc9","code":"ContentSection_code__cBko-"};